import {
  AfterViewInit,
  ChangeDetectorRef,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

import { Swiper } from 'swiper';
import { SwiperOptions } from 'swiper/types/swiper-options';

import { SsrHelperService } from '../../core/services/ssr-helper.service';

@Directive({
  selector: '[appSwiper]',
  standalone: true,
  exportAs: 'swiperRef',
})
export class SwiperDirective implements OnInit, AfterViewInit, OnDestroy {
  @Input({ required: true }) swiperOptions: SwiperOptions;

  @Output() slideChange = new EventEmitter<number>();

  swiperInstance: Swiper | null = null;

  constructor(
    private el: ElementRef,
    private ssrHelperService: SsrHelperService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    if (this.ssrHelperService.userAgent && this.el && this.el.nativeElement) {
      this.ssrHelperService.setSwiperContainer(
        this.el.nativeElement,
        this.swiperOptions,
        (swiper) => {
          this.swiperInstance = swiper;
          this.swiperInstance.on('slideChange', () =>
            this.slideChange.emit(swiper.realIndex),
          );
          this.slideChange.emit(swiper.activeIndex);
          return swiper;
        },
      );
    }
  }

  ngAfterViewInit() {
    this.cdr.markForCheck();
  }

  ngOnDestroy() {
    this.ssrHelperService.destroySwiper(this.swiperInstance);
  }

  /**
   * This ViewChild reference allows direct access to the SwiperDirective instance.
   * It provides the ability to interact with its methods, such as `updateSwiper()`,
   * which is used to refresh the Swiper instance after dynamic content changes.
   *
   * Example:
   * @ViewChild(SwiperDirective) swiper!: SwiperDirective;
   * @ViewChildren(SwiperDirective) swipers!: QueryList<SwiperDirective>;
   */
  updateSwiper(): void {
    this.ssrHelperService.updateSwiper(this.swiperInstance);
  }
}
